export default "__VITE_ASSET__LugQ6q90__"